export default __webpack_public_path__ + "static/media/qr_code_tutorial_step_two.f70cd96e.png";